import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Iconz extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const type = this.props.type, size = this.props.size, children = this.props.children;
        return (
            <i className={"iconfont " + type} style={{fontSize: (size ? size : 24), marginRight: 10}}>{children}</i>
        );
    }
}

Iconz.propTypes = {
    type: PropTypes.string, //类型
    size: PropTypes.number, //图标大小
}

class Svg extends Component {
    render() {
        const type = this.props.type, size = this.props.size || 36;
        return (
            <svg className="icon-svg" aria-hidden="true" width={size} height={size}>
                <use xlinkHref={"#" + type}></use>
            </svg>
        )
    }
}

Svg.propTypes = {
    type: PropTypes.string,//类型
    size: PropTypes.number,//大小
}

Iconz.Svg = Svg;

export default Iconz;



// WEBPACK FOOTER //
// ./src/components/Iconz.jsx